import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoHeader from '../Inicio/components/LogoHeader'; 

function PaquetesPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(link);
  }, []);

  const paquetes = [
    { 
      id: 1, 
      titulo: 'Paquete Básico', 
      imagen: 'img/PAQUET_Basic.jpg',
      desc: 'Ideal para grupos pequeños. Incluye sonido básico y luces rítmicas.',
      rating: 3 
    },
    { 
      id: 2, 
      titulo: 'Paquete VIP', 
      imagen: 'img/PAQUET_VIP.jpg', 
      desc: 'Todo incluido para tu evento. Sonido premium, luces robóticas y humo.',
      rating: 4 
    },
    { 
      id: 3, 
      titulo: 'Paquete PREMIUM', 
      imagen: 'img/PAQUET_PREMIUM.jpg', 
      desc: 'Experiencia profesional completa con DJ en vivo y escenario decorado.',
      rating: 5 
    },
  ];

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i key={i} className={i <= rating ? "fa-solid fa-star" : "fa-regular fa-star"} 
           style={{ color: '#FFD700', margin: '0 2px', fontSize: '16px' }}></i>
      );
    }
    return stars;
  };

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      
      {/* 1. HEADER (LOGO) */}
      <div style={{ backgroundColor: '#000' }}>
        <LogoHeader />
      </div>

      {/* 2. BANNER DE ANUNCIO (Estilo Bambo) */}
      <div 
        onClick={() => navigate('/login')}
        style={{ 
          backgroundColor: '#FFD700', 
          color: '#000', 
          padding: '12px', 
          textAlign: 'center', 
          fontWeight: 'bold',
          fontSize: '18px',
          cursor: 'pointer',
          borderBottom: '2px solid #333',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fff'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#FFD700'}
      >
        ⚡ Bono de Descuento de 10% por usuario nuevo ⚡
      </div>

      <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        
        {/* 3. BANNER PRINCIPAL (PANDA) */}
        <div style={{ textAlign: 'center', marginBottom: '50px', position: 'relative' }}>
            <img 
                src="/img/bambo3.jpg" 
                alt="Bambo Promo" 
                style={{ 
                  width: '100%', 
                  maxHeight: '350px', 
                  objectFit: 'cover', 
                  borderRadius: '10px',
                  border: '1px solid #333',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
                }} 
            />
        </div>

        <h2 style={{ 
          fontSize: '32px', 
          marginBottom: '40px', 
          fontWeight: '900', 
          textTransform: 'uppercase',
          letterSpacing: '2px',
          textAlign: 'center'
        }}>
          Nuestros <span style={{ color: '#FFD700' }}>Paquetes</span>
        </h2>

        {/* 4. CONTENEDOR DE CARTAS */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
          {paquetes.map((p) => (
            <div key={p.id} style={{ 
              width: '320px', 
              textAlign: 'center', 
              backgroundColor: '#111', 
              padding: '20px', 
              borderRadius: '15px',
              border: '1px solid #222',
              transition: 'transform 0.3s ease',
              boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ 
                width: '100%', 
                height: '220px', 
                borderRadius: '10px',
                marginBottom: '20px',
                overflow: 'hidden',
                border: '1px solid #333'
              }}>
                <img src={p.imagen} alt={p.titulo} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>

              <h3 style={{ margin: '10px 0', color: '#FFD700', fontWeight: 'bold' }}>{p.titulo}</h3>
              
              <div style={{ marginBottom: '15px' }}>
                {renderStars(p.rating)}
              </div>

              <p style={{ fontSize: '14px', color: '#aaa', height: '60px', overflow: 'hidden', marginBottom: '25px', lineHeight: '1.5' }}>
                {p.desc}
              </p>
              
              <button 
                onClick={() => navigate(`/paquetes/detalle/${p.id}`)}
                style={{ 
                  width: '100%',
                  padding: '12px', 
                  backgroundColor: 'transparent', 
                  color: '#FFD700', 
                  border: '2px solid #FFD700', 
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  borderRadius: '5px',
                  textTransform: 'uppercase',
                  transition: '0.3s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#FFD700';
                  e.currentTarget.style.color = '#000';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#FFD700';
                }}
              >
                Ver Detalles
              </button>
            </div>
          ))}
        </div>

        {/* 5. BOTÓN VOLVER (ESTILO ROJO ORIGINAL) */}
        <div style={{ textAlign: 'center', marginTop: '80px' }}>
            <button 
                onClick={() => navigate('/')}
                style={{ 
                    backgroundColor: '#CC0000', 
                    color: 'white', 
                    padding: '15px 50px', 
                    border: 'none', 
                    fontWeight: 'bold', 
                    cursor: 'pointer',
                    textTransform: 'uppercase',
                    borderRadius: '5px',
                    letterSpacing: '1px'
                }}
            >
                Volver al Inicio
            </button>
        </div>

        <hr style={{ marginTop: '60px', border: '0.1px solid #222' }} />
        <p style={{ color: '#444', fontSize: '11px', fontStyle: 'italic', textAlign: 'center' }}>
          * El rating de los paquetes se actualiza según las opiniones de nuestros clientes.
        </p>
      </div>
    </div>
  );
}

export default PaquetesPage;